import { render, staticRenderFns } from "./NewParentNode.vue?vue&type=template&id=b1a7b3d8&scoped=true&"
import script from "./NewParentNode.vue?vue&type=script&lang=js&"
export * from "./NewParentNode.vue?vue&type=script&lang=js&"
import style0 from "./NewParentNode.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewParentNode.vue?vue&type=style&index=1&id=b1a7b3d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a7b3d8",
  null
  
)

export default component.exports